import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Base_Url } from '../config';

const ProfileForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [previewImage, setPreviewImage] = useState(null);
  
  const [formData, setFormData] = useState({
    designation: '',
    name: '',
    email: '',
    phone: '',
    image: null
  });

  useEffect(() => {
    if (id) {
      fetchProfile();
    }
  }, [id]);

  const fetchProfile = async () => {
    try {
      const response = await fetch(`${Base_Url}/profile/${id}`);
      if (!response.ok) throw new Error('Failed to fetch profile');
      const data = await response.json();
      setFormData({
        ...data,
        image: null
      });
      if (data.image_path) {
        setPreviewImage(`${Base_Url}/${data.image_path}`);
      }
    } catch (err) {
      setError('Failed to load profile data');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, image: file }));
        // crete image path
      const previewUrl = URL.createObjectURL(file);
      setPreviewImage(previewUrl);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const submitData = new FormData();
    Object.keys(formData).forEach(key => {
      if (formData[key] !== null) {
        submitData.append(key, formData[key]);
      }
    });

    try {
      const url = id ? `${Base_Url}/profile/${id}` : `${Base_Url}/profile`;
      const method = id ? 'PUT' : 'POST';
      
      const response = await fetch(url, {
        method,
        body: submitData,
      });

      if (!response.ok) throw new Error('Failed to save profile');
      
      navigate('/profile');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-4">
      <div className="d-flex align-items-center mb-4">
        <button 
          onClick={() => navigate('/profile')}
          className="btn btn-link text-decoration-none me-3"
        >
          Back
        </button>
        <h1 className="h3 mb-0">
          {id ? 'Edit Profile' : 'Create New Profile'}
        </h1>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          <i className="bi bi-exclamation-circle me-2"></i>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="row g-4">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Name *</label>
              <input
                type="text"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                className="form-control"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Designation *</label>
              <input
                type="text"
                name="designation"
                required
                value={formData.designation}
                onChange={handleChange}
                className="form-control"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-control"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Phone</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="form-control"
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Profile Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="form-control"
              />
              {previewImage && (
                <img 
                  src={previewImage}
                  alt="Preview" 
                  className="mt-2 img-thumbnail"
                  style={{ maxWidth: '150px' }}
                />
              )}
            </div>
          </div>
          <div className="col-md-12">
          <div className="mb-3">
              <label className="form-label">Work Summary</label>
              <textarea
                name="summary"
                value={formData.summary}
                onChange={handleChange}
                rows="4"
                className="form-control"
              />
            </div>
          </div>
        </div>
        

        <div className="text-end">
          <button
            type="button"
            onClick={() => navigate('/profile')}
            className="btn btn-secondary me-2"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary"
          >
            {loading ? 'Saving...' : 'Save Profile'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProfileForm;